import autocomplete from 'autocompleter';
window.autocomplete = autocomplete;
